/* eslint-disable max-lines */
/* eslint-disable indent */
/* eslint-disable max-lines */
/* eslint-disable max-statements */
/* eslint-disable complexity */
/* eslint-disable array-callback-return */
/* eslint-disable max-lines-per-function */
/* eslint-disable operator-linebreak */
import errorImage from 'static/images/error.svg';
import {
    USER_STATUS,
    USER_LEVEL,
    ROLE_STATUS,
    ROLE_MAP,
    TEST_PREFIX,
    pieLegends,
} from './constants/commonValues';
import moment from 'moment';
import { isEmpty, orderBy, unionBy, first, capitalize } from 'lodash';

/**
 * Stringifies and stores data in local storage
 *
 * @param  {string} key - Key name
 * @param  {instanceOf(Object)} data - Data to be stored in localStorage
 * @returns {undefined}
 */
export const setToLocalStorage = (key, data) => {
    localStorage.setItem(key, JSON.stringify(data));
};

/**
 * Fetches and parses data from local storage
 *
 * @param  {string} key - Key name
 * @returns {instanceOf(Object)} - data from local storage
 */
export const getFromLocalStorage = key => {
    return (localStorage && JSON.parse(localStorage.getItem(key))) || null;
};

/**
 * Removes a key from local storage
 *
 * @param {String} key - Key Name
 * @returns {undefined}
 */
export const removeFromLocalStorage = key => {
    localStorage.removeItem(key);
};

export const getLoginRedirectPath = (resources = [], permissions = []) => {
    if (resources.includes('access_management')) {
        if (permissions.access_management.includes('role_management')) {
            return '/rolemanagement';
        } else if (permissions.access_management.includes('user_management')) {
            return '/usermanagement';
        } else if (permissions.access_management.includes('userverification')) {
            return '/userverification';
        }
    }

    if (resources.includes('merchant_onboarding')) {
        return '/mob';
    }
    if (resources.includes('edit_merchant_onboarding')) {
        return '/mob';
    }

    if (resources.includes('reports')) {
        return '/transactions';
    }

    if (resources.includes('refunds')) {
        return '/refund';
    }
};

export const NUMERIC = {
    zero: 0,
    one: 1,
    two: 2,
    three: 3,
    four: 4,
    five: 5,
    six: 6,
    seven: 7,
    eight: 8,
    nine: 9,
    ten: 10,
    twenty: 20,
    forty: 40,
    hundred: 100,
};

/**
 * Join array values with Pipe |.
 *
 * @param {values} array - Input array of values
 * @returns {String} - Will return the string with piped joined.
 */

export const getPipeSeparateValue = values => values.join(' | ');

/**
 * Returns sum of digits of a number
 *
 * @param {Number} number - Input number
 * @returns {Number} sum - Sum of digits
 */
export const sumOfDigits = value => {
    let number = value;
    const { ten, zero } = NUMERIC;
    let sum = zero;
    while (number) {
        const lastDigit = number % ten;
        number = Math.floor(number / ten);
        sum = sum + lastDigit;
    }
    return sum;
};

/**
 * Checks whether a given number is luhn number or not
 *
 * @param {Number} number - Input number
 * @returns {Boolean} - True: if number is luhn number; False: if number is not luhn number
 */
export const isLuhnNumber = value => {
    const { one, zero, ten, twenty, nine, two, three } = NUMERIC;
    let number = value;
    let count = one;
    let sum = zero;
    while (number) {
        const lastDigit = number % ten;
        number = Math.floor(number / ten);
        sum =
            sum +
            // eslint-disable-next-line no-nested-ternary
            (count === two
                ? (lastDigit * two) % twenty > nine
                    ? sumOfDigits(lastDigit * two)
                    : lastDigit * two
                : lastDigit);
        count++;
        count = count === three ? one : count;
    }
    return sum % ten === zero;
};

export function humanDate(timestamp, isDateString) {
    if (isDateString) {
        return new Date(timestamp)
            .toISOString()
            .replace('T', ' ')
            .replace(/\.\d+Z$/, '');
    }
    return new Date(timestamp).toLocaleDateString('en-US', {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
    });
}

export const getUserStatus = data => {
    const userStatus = USER_STATUS;
    if (data && data.userStatus) {
        switch (data.userStatus) {
            case userStatus.CHECKER_VERIFIED:
                return [
                    {
                        name: userStatus.CHECKER_VERIFIED,
                        value: 'CHECKER_VERIFIED',
                    },
                ];
            case userStatus.ACTIVE:
            case userStatus.INACTIVE:
                return [
                    {
                        name: userStatus.ACTIVE,
                        value: 'ACTIVE',
                    },
                    {
                        name: userStatus.INACTIVE,
                        value: 'INACTIVE',
                    },
                ];

            default:
                return [];
        }
    }
    return [];
};

export const getRoleStatusOptions = () => {
    const options = [];
    for (const key in ROLE_STATUS) {
        if (Object.prototype.hasOwnProperty.call(ROLE_STATUS, key)) {
            const value = ROLE_STATUS[key];
            options.push({
                label: value,
                value: key,
            });
        }
    }
    return options;
};

export const getUserLevel = entityType => {
    const options = [];
    for (const key in USER_LEVEL) {
        if (Object.prototype.hasOwnProperty.call(USER_LEVEL, key)) {
            const value = USER_LEVEL[key];
            options.push({
                name: value,
                value: key,
            });
        }
    }
    if (entityType) {
        if (entityType === 'ADMIN') {
            const adminValues = [
                {
                    name: 'Admin',
                    value: 'ADMIN',
                },
            ];
            return [...adminValues];
        }

        if (entityType !== 'ADMIN') {
            const newOptions = options.filter(item => item.value !== 'ADMIN');

            return newOptions;
        }
    }
    return options;
};

export const getStatusMap = value => {
    return Object.keys(USER_STATUS).find(key => USER_STATUS[key] === value);
};

export const getId = name => {
    if (name) {
        const idName = name.split(' ').join('-', '.');
        return idName && idName.toLowerCase();
    }
    return '';
};

const modifyLabelString = (splitStr) => {
    let modifiedStr = splitStr.join(' ');
    if (modifiedStr && typeof modifiedStr === 'string') {
        modifiedStr = modifiedStr
            .replace(/\bqr\b/gi, 'QR')
            .replace(/\bsdk\b/gi, 'SDK')
            .replace(/\bcc\b/gi, 'CC')
            .replace(/\b\( \b/gi, '\(')
            .replace(/\b \)\b/gi, '\)')
    }
    return modifiedStr;
}

export const capitaliseString = str => {
    const splitStr = str.toLowerCase().split(' ');
    for (let i = 0; i < splitStr.length; i++) {
        splitStr[i] =
            splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
    }

    // Return the joined string
    return modifyLabelString(splitStr);
};

export const capitalizeStringWithUnderscores = str => {
    if (typeof str !== 'string') {
        return str;
    }

    const words = str.split('_');
    const capitalizedWords = words.map(
        word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
    );
    return modifyLabelString(capitalizedWords);
};

export const getRoleStatusMap = value => {
    return Object.keys(ROLE_MAP).find(key => ROLE_MAP[key] === value);
};

export const getFlatEntities = (values, entityType) => {
    const entities = {};
    if (entityType === 'AGGREGATOR') {
        if (values.franchise.length) {
            entities.franchise = values.franchise || [];
        } else {
            entities.franchise = [];
        }
    } else if (entityType === 'AGGREGATOR_TXN') {
        if (values.merchants.length) {
            entities.merchants = values.merchants || [];
        } else {
            entities.merchants = [];
        }
    }
    return entities;
};

/**
 * Segregate the configured and non configured pgs.
 *
 * @param {Array} Object - Array of pg objects
 * @returns {Object} - Object of configured and noConfigured Pgs
 */

export const segregatePgByConfig = pgList => {
    if (pgList.length > 0) {
        const configuredPgs = pgList.filter(item => item.isConfigured);
        const nonConfiguredPgs = pgList.filter(item => !item.isConfigured);
        return { configuredPgs, nonConfiguredPgs };
    }
    return { configuredPgs: [], nonConfiguredPgs: [] };
};

export const getFilteredPgsData = (values, data) => {
    const request = {};
    const testConfig = {};
    const liveConfig = {};
    Object.keys(values).forEach(item => {
        if (item.includes('test')) {
            const splitKey = item.split('_');
            const key = splitKey.splice(1, splitKey.length).join('_');
            testConfig[key] = values[item];
        } else {
            liveConfig[item] = values[item];
        }
    });
    if (Object.keys(liveConfig).length) {
        liveConfig.isUpdated = true;
        request[`${data.uniqueId}ConfLive`] = liveConfig;
    }
    if (Object.keys(testConfig).length) {
        testConfig.isUpdated = true;
        request[`${data.uniqueId}ConfTest`] = testConfig;
    }
    return request;
};

export const getFormInitialValues = (values, data) => {
    const liveValue = (values && values[`${data.uniqueId}ConfLive`]) || {};
    const testValue = (values && values[`${data.uniqueId}ConfTest`]) || {};

    const testInitialValues = {};
    Object.keys(testValue).forEach(item => {
        testInitialValues[`${TEST_PREFIX}${item}`] = testValue[item];
    });
    return { ...liveValue, ...testInitialValues };
};

export const getModesOptions = (uniqueId, savedPgs) => {
    const options = [];
    const liveConfig = (savedPgs && savedPgs[`${uniqueId}ConfLive`]) || {};
    const testConfig = (savedPgs && savedPgs[`${uniqueId}ConfTest`]) || {};
    if (Object.keys(testConfig).length) {
        options.push({
            label: 'Test',
            value: 'test',
            checked:
                testConfig &&
                testConfig.credentials.some(
                    cred => cred.status && cred.status[0]?.includes('ENABLED')
                ),
        });
    }
    if (Object.keys(liveConfig).length) {
        options.push({
            label: 'Live',
            value: 'live',
            checked:
                liveConfig &&
                liveConfig.credentials.some(
                    cred => cred.status && cred.status[0]?.includes('ENABLED')
                ),
        });
    }
    return options;
};

export const getFormData = (formType, data, uniqueIdentifier) => {
    if (data) {
        const formData = data.find(
            form =>
                form.type === formType &&
                form.uniqueIdentifier === uniqueIdentifier
        );
        return (formData && formData.sections) || [];
    }
    return [];
};

export const getTimelineStatus = (
    draftData,
    path,
    sectionType,
    currentPath
) => {
    if (draftData && sectionType) {
        const sectionData = draftData.find(
            section => section.type === sectionType
        );
        if (sectionData) {
            return sectionData.state;
        } else if (path.indexOf(currentPath) !== -1) {
            return '';
        }
    }
    return 'pending';
};

const getKeyValue = keyMode => {
    if (keyMode.test && keyMode.live) {
        return 'TEST, LIVE';
    } else if (keyMode.test) {
        return 'TEST';
    } else if (keyMode.live) {
        return 'LIVE';
    }
    return '-';
};

export const getDraftTableData = formData => {
    if (formData && formData.forms && formData.forms.length) {
        const formList = formData.forms;

        const tableData = formList.map(item => {
            const merchantData = item.sections.find(
                elm => elm.type === 'createMerchantSection'
            );
            const integrationData = item.sections.find(
                elm => elm.type === 'integrationSection'
            );
            const merchant = merchantData && merchantData.data;
            let integration = {};
            if (integrationData && integrationData.data) {
                integration = {
                    ...integrationData.data,
                    keyMode: getKeyValue(integrationData.data.keyMode),
                };
            }
            return {
                createdOn: moment(item.createdOn).format('DD/MM/YYYY'),
                merchantIdentifier: item.merchantIdentifier,
                ...merchant,
                ...integration,
            };
        });
        return tableData;
    }
    return [];
};

export function objToArr(data = {}) {
    let newArr = [];

    // eslint-disable-next-line guard-for-in
    for (const key in data) {
        const arr = data[key].map(item => {
            item.type = key;
            return item;
        });
        // newArr.push(arr);
        newArr = [...newArr, ...arr];
    }

    return newArr;
}

const dynamicFieldHandler = (_arr, item) => {
    let arr = _arr;
    const cardType =
        !item.cardType || item.cardType === null ? 'all' : item.cardType;
    const cardCategory = !item.cardCategory ? "All Card Categories" : item.cardCategory;

    item.cardType = cardType;
    item.cardCategory = cardCategory;

    const issuerData = arr.find(bank => bank.cardType === cardType && bank.cardCategory === cardCategory);

    if (issuerData) {
        const updatedList = arr.map(bank => {
            if (bank.cardType === cardType && bank.cardCategory === cardCategory) {
                return {
                    ...bank,
                    cardCategory,
                    bankSlabs: [...bank.bankSlabs, { ...item }],
                };
            }
            return bank;
        });

        arr = [...updatedList];
    } else {
        // Keep all banks option as the first item in the array
        if (
            !item.cardType ||
            item.cardType === null ||
            item.cardType === 'all'
        ) {
            arr = [{ bankSlabs: [{ ...item }], cardType, cardCategory }, ...arr];
        } else {
            arr = [...arr, { bankSlabs: [{ ...item }], cardType, cardCategory }];
        }
    }

    console.log("arr22", arr, item, issuerData);

    return arr;
};

// eslint-disable-next-line max-statements
// eslint-disable-next-line max-lines-per-function
// eslint-disable-next-line max-statements
export const createSurchargeOptions = (data, type = 'default') => {
    // convert obj to arr
    // eslint-disable-next-line no-param-reassign
    data = objToArr(data);

    const debitCard = data.filter(item => item.paymentType === 'DC');
    const creditCard = data.filter(item => item.paymentType === 'CC');
    const netbanking = data.filter(item => item.paymentType === 'NB');
    const upi = data.filter(item => item.paymentType === 'UPI');
    const wallets = data.filter(item => item.paymentType === 'WALLET');
    const AccountVerification = data.filter(
        item => item.paymentType === 'ACCOUNT_VERIFICATION'
    );
    const emi = data.filter(item => item.paymentType === 'EMI_CC');
    const ods = data.filter(item =>
        item.feeType === 'ODS' && item.transactionType === 'ON_DEMAND_SETTLEMENT'
    );

    const domesticDebitCard = [];
    const foreignDebitCard = [];

    let odsData = [];
    if (ods.length) {
        odsData = [
            {
                bankSlabs: ods,
                issuerId: 'all',
            },
        ];
    }

    debitCard.map(item => {
        if (item.domesticFlag) {
            domesticDebitCard.push(item);
        } else {
            foreignDebitCard.push(item);
        }
    });

    const domesticCreditCard = [];
    const foreignCreditCard = [];

    creditCard.map(item => {
        if (item.domesticFlag) {
            domesticCreditCard.push(item);
        } else {
            foreignCreditCard.push(item);
        }
    });

    let domesticDebitCardOnUs = [];
    let domesticDebitCardOffUs = [];

    domesticDebitCard.map(item => {
        if (item.onUsFlag) {
            // domesticDebitCardOnUs.push(item);
            domesticDebitCardOnUs = dynamicFieldHandler(
                domesticDebitCardOnUs,
                item
            );
        } else {
            // domesticDebitCardOffUs.push(item);
            domesticDebitCardOffUs = dynamicFieldHandler(
                domesticDebitCardOffUs,
                item
            );
        }
    });

    let foreignDebitCardOnUs = [];
    let foreignDebitCardOffUs = [];

    foreignDebitCard.map(item => {
        if (item.onUsFlag) {
            // foreignDebitCardOnUs.push(item);
            foreignDebitCardOnUs = dynamicFieldHandler(
                foreignDebitCardOnUs,
                item
            );
        } else {
            // foreignDebitCardOffUs.push(item);
            foreignDebitCardOffUs = dynamicFieldHandler(
                foreignDebitCardOffUs,
                item
            );
        }
    });

    let domesticCreditCardOnUs = [];
    let domesticCreditCardOffUs = [];

    domesticCreditCard.map(item => {
        if (item.onUsFlag) {
            // domesticCreditCardOnUs.push(item);
            domesticCreditCardOnUs = dynamicFieldHandler(
                domesticCreditCardOnUs,
                item
            );
        } else {
            // domesticCreditCardOffUs.push(item);
            domesticCreditCardOffUs = dynamicFieldHandler(
                domesticCreditCardOffUs,
                item
            );
        }
    });

    let foreignCreditCardOnUs = [];
    let foreignCreditCardOffUs = [];

    foreignCreditCard.map(item => {
        if (item.onUsFlag) {
            // foreignCreditCardOnUs.push(item);
            foreignCreditCardOnUs = dynamicFieldHandler(
                foreignCreditCardOnUs,
                item
            );
        } else {
            // foreignCreditCardOffUs.push(item);
            foreignCreditCardOffUs = dynamicFieldHandler(
                foreignCreditCardOffUs,
                item
            );
        }
    });

    let upiData = [];

    if (upi.length) {
        upiData = [
            {
                bankSlabs: upi,
                issuerId: 'all',
            },
        ];
    }

    let netBankingList = [];
    let walletsList = [];
    let AccountVerificationList = [];
    let emiList = [];

    netbanking.map((item, index) => {
        const issuerId =
            !item.issuer || item.issuer === null ? 'all' : item.issuer;

        item.issuerId = issuerId;

        const issuerData = netBankingList.find(
            bank => bank.issuerId === issuerId
        );

        if (issuerData) {
            const updatedList = netBankingList.map(bank => {
                if (bank.issuerId === issuerId) {
                    return {
                        ...bank,
                        bankSlabs: [...bank.bankSlabs, { ...item }],
                    };
                }
                return bank;
            });
            netBankingList = [...updatedList];
        } else {
            // Keep all banks option as the first item in the array
            if (!item.issuer || item.issuer === null) {
                netBankingList = [
                    { bankSlabs: [{ ...item }], issuerId },
                    ...netBankingList,
                ];
            } else {
                netBankingList = [
                    ...netBankingList,
                    { bankSlabs: [{ ...item }], issuerId },
                ];
            }
        }
    });

    wallets.map((item, index) => {
        const issuerId =
            !item.issuer || item.issuer === null ? 'all' : item.issuer;

        item.issuerId = issuerId;

        const issuerData = walletsList.find(bank => bank.issuerId === issuerId);

        if (issuerData) {
            const updatedList = walletsList.map(bank => {
                if (bank.issuerId === issuerId) {
                    return {
                        ...bank,
                        bankSlabs: [...bank.bankSlabs, { ...item }],
                    };
                }
                return bank;
            });
            walletsList = [...updatedList];
        } else {
            // Keep all banks option as the first item in the array
            if (!item.issuer || item.issuer === null) {
                walletsList = [
                    { bankSlabs: [{ ...item }], issuerId },
                    ...walletsList,
                ];
            } else {
                walletsList = [
                    ...walletsList,
                    { bankSlabs: [{ ...item }], issuerId },
                ];
            }
        }
    });

    AccountVerification.map((item, index) => {
        const issuerId =
            !item.issuer || item.issuer === null ? 'all' : item.issuer;

        item.issuerId = issuerId;

        const issuerData = AccountVerificationList.find(
            bank => bank.issuerId === issuerId
        );

        if (issuerData) {
            const updatedList = AccountVerificationList.map(bank => {
                if (bank.issuerId === issuerId) {
                    return {
                        ...bank,
                        bankSlabs: [...bank.bankSlabs, { ...item }],
                    };
                }
                return bank;
            });
            AccountVerificationList = [...updatedList];
        } else {
            // Keep all banks option as the first item in the array
            if (!item.issuer || item.issuer === null) {
                AccountVerificationList = [
                    { bankSlabs: [{ ...item }], issuerId },
                    ...AccountVerificationList,
                ];
            } else {
                AccountVerificationList = [
                    ...AccountVerificationList,
                    { bankSlabs: [{ ...item }], issuerId },
                ];
            }
        }
    });

    emi.map((item, index) => {
        const issuerId =
            !item.issuer || item.issuer === null ? 'all' : item.issuer;
        item.issuerId = issuerId;
        const issuerData = emiList.find(bank => bank.issuerId === issuerId);
        if (issuerData) {
            const updatedList = emiList.map(bank => {
                if (bank.issuerId === issuerId) {
                    return {
                        ...bank,
                        bankSlabs: [...bank.bankSlabs, { ...item }],
                    };
                }
                return bank;
            });
            emiList = [...updatedList];
        } else {
            // Keep all banks option as the first item in the array
            if (!item.issuer || item.issuer === null) {
                emiList = [{ bankSlabs: [{ ...item }], issuerId }, ...emiList];
            } else {
                emiList = [...emiList, { bankSlabs: [{ ...item }], issuerId }];
            }
        }
    });

    const surchargeOptions = {
        sections: [
            'Domestic-Debit-Card-On-Us',
            'Domestic-Debit-Card-Off-Us',
            'Foreign-Debit-Card-On-Us',
            'Foreign-Debit-Card-Off-Us',
            'Domestic-Credit-Card-On-Us',
            'Domestic-Credit-Card-Off-Us',
            'Foreign-Credit-Card-On-Us',
            'Foreign-Credit-Card-Off-Us',
            'Net-Banking',
            'UPI',
            'Wallets',
            'AccountVerification',
            'emi',
            'ODS',
        ],
        slabs: {
            'Domestic-Debit-Card-On-Us': domesticDebitCardOnUs,
            'Domestic-Debit-Card-Off-Us': domesticDebitCardOffUs,
            'Foreign-Debit-Card-On-Us': foreignDebitCardOnUs,
            'Foreign-Debit-Card-Off-Us': foreignDebitCardOffUs,
            'Domestic-Credit-Card-On-Us': domesticCreditCardOnUs,
            'Domestic-Credit-Card-Off-Us': domesticCreditCardOffUs,
            'Foreign-Credit-Card-On-Us': foreignCreditCardOnUs,
            'Foreign-Credit-Card-Off-Us': foreignCreditCardOffUs,
            'Net-Banking': netBankingList,
            UPI: upiData,
            Wallets: walletsList,
            AccountVerification: AccountVerificationList,
            emi: emiList,
            ODS: odsData,
        },
    };

    return surchargeOptions;
};

export const getDynamicBoolValues = (data, key) => {
    if (data && data[key]) {
        const boolValue = data[key] || false;
        if (boolValue === true || boolValue === key) {
            return [key];
        } else if (Array.isArray(boolValue) && boolValue.includes(key)) {
            return [key];
        }
    }
    return [];
};

export const getDynamicBoolFromArray = (values, key) => {
    const boolValues = values && values.length && values.includes(key);
    return boolValues || false;
};
let count = 0;

const getcustomisedReportsData = (editData) =>{
    count++;
    //console.log(count,editData,"cccccc");
    // debugger;
    if(editData.customisedReports != undefined){
        return editData;
    }
    else {
        return {...editData.settlementDataSection, customisedReports: editData.customisedReports};
    }
}

const getFilteredSectionData = (editData, sectionType) => {
    //console.log(editData, "consoling edit data in helper methods 1234")
    switch (sectionType) {
        case 'createMerchantSection':
            return (editData && editData.entityDetails) || {};
        case 'integrationSection':
            return (editData && editData.integrationData) || {};
        case 'paymentModeSection':
            return (editData && editData.paymentModeData) || {};
        case 'settlementSection':
            return (editData && getcustomisedReportsData(editData)) || {};
        case 'kycSection':
            return (editData && editData.kycData) || {};
        case 'pgConfigurationSection':
            return (editData && editData.pgConfigurationDataResponse) || {};
        case 'dynamicRoutingSection':
            return (
                (editData &&
                    editData.pgRoutingResponseList && {
                    enableDynamicRouting: getDynamicBoolValues(
                        editData,
                        'enableDynamicRouting'
                    ),
                    pgRoutingRequestList: editData.pgRoutingResponseList,
                }) ||
                {}
            );
        case 'surchargeSection':
            return (
                (editData &&
                    editData.feeConfigListMap && {
                    feeConfigList: createSurchargeOptions(
                        editData.feeConfigListMap,
                        'draft'
                    ).slabs,
                }) ||
                {}
            );
        case 'notificationSection':
            return (editData && editData.notificationData) || {};
        default:
            return [];
    }
};


export const getFormattedSectionData = (editData, sections, singleSection) => {
    const sectionData = [];
    if (singleSection) {
        return [
            {
                type: singleSection,
                state: 'Complete',
                data: getFilteredSectionData(editData, singleSection),
            },
        ];
    }
    sections.forEach(section => {
        sectionData.push({
            type: section.sectionType,
            state: 'Complete',
            data: getFilteredSectionData(editData, section.sectionType),
        });
    });
    return sectionData;
};

export const shortFormatedData = (data) => {
    const sortedData = data.map((section) => {
        if (section.type === "surchargeSection" && section.data && section.data.feeConfigList) {
            const feeConfigList = section.data.feeConfigList;

            // Iterate over each feeConfigList entry and sort `bankSlabs`
            Object.keys(feeConfigList).forEach((key) => {
                feeConfigList[key] = feeConfigList[key].map((config) => {
                    if (config.bankSlabs && config.bankSlabs.length > 0) {
                        config.bankSlabs = config.bankSlabs.sort((a, b) => {
                            if (a.cardCategory === "CORPORATE" && b.cardCategory !== "CORPORATE") return -1;
                            if (a.cardCategory !== "CORPORATE" && b.cardCategory === "CORPORATE") return 1;
                            if (a.cardCategory === "CORPORATE" && b.cardCategory === "CORPORATE") {
                                // Place ESF before MDR within corporate items
                                return a.feeType === "ESF" ? -1 : 1;
                            }
                            return 0;
                        });
                    }
                    return config;
                });
            });

            return { ...section, data: { ...section.data, feeConfigList } };
        }
        return section;
    });

    return sortedData;
}

export const isObjectEmpty = obj => {
    for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
            return false;
        }
    }
    return true;
};

export const debounce = (func, wait, immediate) => {
    let timeout;

    return function executedFunction() {
        // eslint-disable-next-line consistent-this, no-invalid-this
        const context = this;
        const args = arguments;

        const later = () => {
            timeout = null;
            if (!immediate) {
                func.apply(context, args);
            }
        };

        const callNow = immediate && !timeout;

        clearTimeout(timeout);

        timeout = setTimeout(later, wait);

        if (callNow) {
            func.apply(context, args);
        }
    };
};
const colours = [
    '#1abc9c',
    '#2ecc71',
    '#3498db',
    '#9b59b6',
    '#34495e',
    '#16a085',
    '#27ae60',
    '#2980b9',
    '#8e44ad',
    '#2c3e50',
    '#f1c40f',
    '#e67e22',
    '#e74c3c',
    '#95a5a6',
    '#f39c12',
    '#d35400',
    '#c0392b',
    '#bdc3c7',
    '#7f8c8d',
];
export const getInitials = name => {
    if (name) {
        const intials = name
            .replace(/[^A-Za-z0-9À-ÿ ]/gi, '')
            .replace(/ +/gi, ' ')
            .split(/ /)
            .reduce((acc, item) => acc + item[0], '')
            .concat(name.substr(1))
            .concat(name)
            .substr(0, 2)
            .toUpperCase();

        const charIndex = intials.charCodeAt(0) - 65;
        const colourIndex = charIndex % 19;
        const colour = colours[colourIndex];
        return {
            name: intials,
            colour,
        };
    }
    return {
        name: '',
        colour: '',
    };
};

export const getUserPermissionFromResourceDetails = resourceDetails => {
    const resources = [];
    const permissions = {};
    const permissionMap = {};
    resourceDetails.forEach(resource => {
        resources.push(resource.resourceName);
        permissions[resource.resourceName] = resource.permissionDetail.map(
            perm => {
                permissionMap[perm.permissionName] = perm.permissionName;

                if (
                    perm.subPermissionDetails &&
                    perm.subPermissionDetails.length > 0
                ) {
                    perm.subPermissionDetails.forEach(subPermission => {
                        permissionMap[subPermission.permissionName] =
                            subPermission.permissionName;
                    });
                }

                return perm.permissionName;
            }
        );
    });

    return {
        resources,
        permissions,
        permissionMap,
    };
};

export const getFlatSelectedData = (values, entityType, currentEntityCode) => {
    const entities = {
        aggregator: '',
        franchise: '',
        mle: '',
    };

    let aggregator = '';
    let franchise = '';
    let mle = '';

    if (entityType === 'AGGREGATOR') {
        aggregator = currentEntityCode;
    } else if (entityType === 'FRANCHISE') {
        franchise = currentEntityCode;
    } else {
        mle = currentEntityCode;
    }

    if (values.parent) {
        const { entityCode, entityType } = values.parent;
        if (entityType === 'AGGREGATOR') {
            aggregator = entityCode;
        } else if (entityType === 'FRANCHISE') {
            franchise = entityCode;
        } else {
            mle = entityCode;
        }

        if (values.parent.parent) {
            const { entityCode, entityType } = values.parent.parent;
            if (entityType === 'AGGREGATOR') {
                aggregator = entityCode;
            } else if (entityType === 'FRANCHISE') {
                franchise = entityCode;
            } else {
                mle = entityCode;
            }
        }
    }
    entities.aggregator = aggregator;
    entities.franchise = franchise;
    entities.mle = mle;
    return entities;
};

export const isValuesEmpty = values => {
    if (values) {
        const allValues = Object.values(values);
        const checkAllValues = allValues.some(item => !isEmpty(item));
        return checkAllValues ? false : true;
    }

    return isEmpty(values);
};

export const filterNotFillSection = (list, notIncludeSectionType) => {
    if (list && list.length) {
        const filterSection = list.filter(
            item =>
                item.sectionType !== notIncludeSectionType &&
                item.status === 'Open'
        );

        const sections =
            filterSection && filterSection.map(item => item.name).join(', ');
        return sections || 'All';
    }
    return 'All';
};

export const getDependentSectionName = (steps, dependentSections) => {
    if (
        steps &&
        steps.length &&
        dependentSections &&
        dependentSections.length
    ) {
        const filterSection = steps.filter(
            item => dependentSections.includes(item.sectionType)
            // eslint-disable-next-line function-paren-newline
        );

        const sections =
            filterSection && filterSection.map(item => item.name).join(', ');
        return sections || '';
    }
    return '';
};

export const formatBoolean = data => {
    if (data === true) {
        return 'True';
    } else if (data === false) {
        return 'False';
    }
    return '-';
};

export const getFormattedData = (data, staticData) => {
    if (!isEmpty(data) && !isEmpty(staticData)) {
        const cardNatureData = staticData.CARD_NATURE;
        const bankCodeData = staticData.BANK_CODE;
        const cardTypeData = staticData.CARD_TYPE;

        const {
            binBlocked,
            binHead,
            cardNature,
            cardType,
            created,
            emiBin,
            isDomestic,
            issuingBank,
            lastUpdated,
        } = data;
        return {
            binBlocked: formatBoolean(binBlocked),
            binHead: binHead || '-',
            cardNature:
                (cardNatureData[cardNature] &&
                    cardNatureData[cardNature].codeNameUI) ||
                '-',
            cardType:
                (cardTypeData[cardType] && cardTypeData[cardType].codeNameUI) ||
                '-',
            created: moment(created).format('DD/MM/YYYY') || '-',
            emiBin: formatBoolean(emiBin),
            isDomestic: formatBoolean(isDomestic),
            issuingBank:
                (bankCodeData[issuingBank] &&
                    bankCodeData[issuingBank].codeNameUI) ||
                '-',
            lastUpdated: moment(lastUpdated).format('DD/MM/YYYY') || '-',
        };
    }
    return {};
};

const getFormattedStaticData = (data, compareValue) => {
    return data.find(
        item =>
            item.label.toUpperCase().replace(/\s/g, '') ===
            compareValue.toUpperCase().replace(/\s/g, '')
    );
};

export const getInitialsEditBin = (initialValues, staticData) => {
    if (!isEmpty(initialValues) && !isEmpty(staticData)) {
        const cardNatureData = getBinOptions(staticData.CARD_NATURE);
        const bankCodeData = getBinOptions(staticData.BANK_CODE);
        const cardTypeData = getBinOptions(staticData.CARD_TYPE);

        const initialValuesCopy = { ...initialValues };
        delete initialValuesCopy.created;
        delete initialValuesCopy.lastUpdated;
        if (initialValuesCopy.binBlocked) {
            initialValuesCopy.binBlocked = JSON.parse(
                initialValuesCopy.binBlocked.toLowerCase()
            );
        }
        if (initialValuesCopy.emiBin) {
            initialValuesCopy.emiBin = JSON.parse(
                initialValuesCopy.emiBin.toLowerCase()
            );
        }
        if (initialValuesCopy.isDomestic) {
            initialValuesCopy.isDomestic = JSON.parse(
                initialValuesCopy.isDomestic.toLowerCase()
            );
        }
        if (initialValuesCopy.cardNature) {
            const formattedCardNature = getFormattedStaticData(
                cardNatureData,
                initialValuesCopy.cardNature
            );
            initialValuesCopy.cardNature =
                (formattedCardNature && formattedCardNature.value) || '';
        }
        if (initialValuesCopy.cardType) {
            const formattedCardType = getFormattedStaticData(
                cardTypeData,
                initialValuesCopy.cardType
            );
            initialValuesCopy.cardType =
                (formattedCardType && formattedCardType.value) || '';
        }
        if (initialValuesCopy.issuingBank) {
            const formattedBankType = getFormattedStaticData(
                bankCodeData,
                initialValuesCopy.issuingBank
            );
            initialValuesCopy.issuingBank =
                (formattedBankType && formattedBankType.value) || '';
        }
        return initialValuesCopy;
    }
    return {};
};

export const formatTableData = (tableData, staticData) => {
    if (tableData && tableData.length && !isEmpty(staticData)) {
        const cardNature = staticData.CARD_NATURE;
        const bankCode = staticData.BANK_CODE;
        const cardType = staticData.CARD_TYPE;

        const formattedData = tableData.map(item => {
            const itemCopy = { ...item };
            if (cardNature[itemCopy.cardNature]) {
                itemCopy.cardNature =
                    cardNature[itemCopy.cardNature].codeNameUI || '-';
            }
            if (cardType[itemCopy.cardType]) {
                itemCopy.cardType =
                    cardType[itemCopy.cardType].codeNameUI || '-';
            }
            if (bankCode[itemCopy.issuingBank]) {
                itemCopy.issuingBank =
                    bankCode[itemCopy.issuingBank].codeNameUI || '-';
            }
            return itemCopy;
        });
        return formattedData;
    }
    return tableData;
};

export const replaceUnderscoresWithSpaces = (str) => {
    return str.replace(/_/g, ' ');
};

export const getBinOptions = (values, withAllBank) => {
    if (values) {
        const options = Object.keys(values).map(item => {
            const itemObject = values[item];
            return {
                label: itemObject.codeNameUI,
                value: item,
                image: itemObject.imagePath,
            };
        });
        const orderedOptions = orderBy(options, ['label'], ['asc']);
        if (withAllBank) {
            orderedOptions.unshift({
                label: 'All Bank',
                value: 'all',
                image: '',
            });
        }
        return orderedOptions;
    }
    return [];
};

export const getSurchargeBankOptions = (
    bankCodes,
    paymentOptions = [],
    withAllBank
) => {
    const options = paymentOptions
        .filter(item => item.paymentType === 'NB' && item.issuer)
        .map(item => {
            return {
                label: bankCodes[item.issuer].codeNameUI,
                value: item.issuer,
                image: bankCodes[item.issuer].imagePath,
            };
        });

    const orderedOptions = orderBy(options, ['label'], ['asc']);
    if (withAllBank) {
        orderedOptions.unshift({
            label: 'All Bank',
            value: 'all',
            image: '',
        });
    }

    return orderedOptions;
};

export const getWalletOptions = (wallets = [], withAllWallets) => {
    const options = wallets
        .filter(item => item.paymentType === 'WALLET' && item.issuer)
        .map(item => {
            return {
                label: item.issuer,
                value: item.issuer,
            };
        });
    const orderedOptions = orderBy(options, ['label'], ['asc']);
    if (withAllWallets) {
        orderedOptions.unshift({
            label: 'All Wallet',
            value: 'all',
        });
    }

    return orderedOptions;
};

export const getSchemeOptions = (schemes = []) => {
    const cardOptions = {
        AMEX: 'AMEX',
        VI: 'VISA',
        MC: 'MASTERCARD',
        RPAY: 'RUPAY',
        DINR: 'DINER',
        SDK: 'SDK'
    };

    const options = schemes
        .filter(scheme => scheme !== 'All Schemes')
        .map(scheme => {
            return {
                label: cardOptions[scheme],
                value: scheme,
            };
        });

    return options;
};

const getExtraOptionsPermission = (oldPermission, newPermission, permId) => {
    const permIdListOld = oldPermission.map(perm => perm.permissionId);
    const permIdListNew = newPermission.map(perm => perm.permissionId);
    const extraOption = {
        checked: false,
        isPrevious: false,
        isChanged: false,
    };
    if (permIdListOld.includes(permId) && permIdListNew.includes(permId)) {
        extraOption.checked = true;
    } else if (
        !permIdListOld.includes(permId) &&
        permIdListNew.includes(permId)
    ) {
        extraOption.checked = true;
        extraOption.isChanged = true;
    } else if (
        permIdListOld.includes(permId) &&
        !permIdListNew.includes(permId)
    ) {
        extraOption.isPrevious = true;
    }

    return extraOption;
};

export const getPermissionsOptions = (oldData, newData, key, isMob) => {
    if (oldData || newData) {
        const permissionResourceOld = oldData.find(
            res => res.resourceName === key
        );
        const permissionResourceNew = newData.find(
            res => res.resourceName === key
        );
        const oldPermissionDetail =
            (permissionResourceOld && permissionResourceOld.permissionDetail) ||
            [];
        const newPermissionDetail =
            (permissionResourceNew && permissionResourceNew.permissionDetail) ||
            [];

        const mergedOptions = unionBy(
            oldPermissionDetail,
            newPermissionDetail,
            'permissionName'
        );
        if (isMob) {
            let mobMappedValues = [];

            if (newPermissionDetail.length > 0) {
                const havePermission =
                    newPermissionDetail.length > 0 ? true : false;
                mobMappedValues = [
                    {
                        label: 'Merchant Onboarding',
                        value: newPermissionDetail[0].value,
                        checked: havePermission,
                        isChanged: havePermission,
                        isPrevious: false,
                    },
                ];
            } else if (oldPermissionDetail.length > 0) {
                mobMappedValues = [
                    {
                        label: 'Merchant Onboarding',
                        value: oldPermissionDetail[0].value,
                        checked: false,
                        isChanged: false,
                        isPrevious: true,
                    },
                ];
            }
            return mobMappedValues;
        }

        const mappedValues = mergedOptions.map(perm => {
            const extraOpt = getExtraOptionsPermission(
                oldPermissionDetail,
                newPermissionDetail,
                perm.permissionId
            );
            return {
                label: capitaliseString(
                    perm.permissionName.split('_').join(' ')
                ),
                value: perm.permissionId,
                ...extraOpt,
            };
        });
        return mappedValues;
    }
    return [];
};

export const getIntent = value => {
    if (value && value === 'Update') {
        return 'Last Edit :';
    }
    return 'Created By :';
};

const getConvertedDate = date => {
    if (!date) {
        return '-';
    }
    return moment(date).format('DD/MM/YYYY');
};

export const getPgDate = (key, values) => {
    if (key && values) {
        const liveValue = values[`${key}ConfLive`];
        const testValue = values[`${key}ConfTest`];
        if (liveValue) {
            if (liveValue.lastUpdated) {
                return getConvertedDate(liveValue.lastUpdated);
            }
            return getConvertedDate(liveValue.created);
        } else if (testValue) {
            if (testValue.lastUpdated) {
                return getConvertedDate(testValue.lastUpdated);
            }
            return getConvertedDate(testValue.created);
        }
        return '-';
    }
    return '-';
};

export const getRmName = (emailId, relationshipManagers) => {
    const rmName =
        relationshipManagers &&
        relationshipManagers.find(item => item.email === emailId);
    return (rmName && rmName.name) || '-';
};

export const getFormattedDate = date => {
    const formatDate = {
        startDate: '',
        endDate: '',
    };
    if (!date && !date.value) {
        return formatDate;
    }
    if (date.value === 'custom' && date.endDate && date.startDate) {
        formatDate.startDate = moment(date.startDate)
            .startOf('day')
            .format('YYYY-MM-DD HH:mm:ss');
        if (moment(date.endDate).isAfter(moment())) {
            formatDate.endDate = moment().format('YYYY-MM-DD HH:mm:ss');
        } else {
            formatDate.endDate = moment(date.endDate)
                .endOf('day')
                .format('YYYY-MM-DD HH:mm:ss');
        }
    } else {
        const hourString = '01:00:00',
            hourStringPrt = hourString.split(':'),
            minuteDelta = Number(hourStringPrt[1]),
            hourDelta = Number(hourStringPrt[0]);

        switch (date.value) {
            case '1Hour': {
                formatDate.startDate = moment()
                    .subtract({ hours: hourDelta, minutes: minuteDelta })
                    .format('YYYY-MM-DD HH:mm:ss');
                formatDate.endDate = moment().format('YYYY-MM-DD HH:mm:ss');
                return formatDate;
            }
            case 'today': {
                formatDate.startDate = moment()
                    .startOf('day')
                    .format('YYYY-MM-DD HH:mm:ss');
                formatDate.endDate = moment().format('YYYY-MM-DD HH:mm:ss');
                return formatDate;
            }
            case 'yesterday': {
                formatDate.startDate = moment()
                    .subtract(1, 'days')
                    .startOf('day')
                    .format('YYYY-MM-DD HH:mm:ss');
                formatDate.endDate = moment()
                    .subtract(1, 'days')
                    .endOf('day')
                    .format('YYYY-MM-DD HH:mm:ss');
                return formatDate;
            }
            case '7Days': {
                formatDate.startDate = moment()
                    .subtract(7, 'days')
                    .startOf('day')
                    .format('YYYY-MM-DD HH:mm:ss');
                formatDate.endDate = moment()
                    .subtract(1, 'days')
                    .endOf('day')
                    .format('YYYY-MM-DD HH:mm:ss');
                return formatDate;
            }
            case '30Days': {
                formatDate.startDate = moment()
                    .subtract(30, 'days')
                    .startOf('day')
                    .format('YYYY-MM-DD HH:mm:ss');
                formatDate.endDate = moment()
                    .subtract(1, 'days')
                    .startOf('day')
                    .format('YYYY-MM-DD HH:mm:ss');
                return formatDate;
            }
            case '180Days': {
                formatDate.startDate = moment()
                    .subtract(180, 'days')
                    .startOf('day')
                    .format('YYYY-MM-DD HH:mm:ss');
                formatDate.endDate = moment()
                    .subtract(1, 'days')
                    .startOf('day')
                    .format('YYYY-MM-DD HH:mm:ss');
                return formatDate;
            }
            case '1Year': {
                formatDate.startDate = moment()
                    .subtract(365, 'days')
                    .startOf('day')
                    .format('YYYY-MM-DD HH:mm:ss');
                formatDate.endDate = moment()
                    .subtract(1, 'days')
                    .startOf('day')
                    .format('YYYY-MM-DD HH:mm:ss');
                return formatDate;
            }
            default:
                return formatDate;
        }
    }
    return formatDate;
};

export const formatPieChartData = (item, { payValues }) => {
    if (item && item.length && payValues) {
        const staticValues = {
            ...payValues.CARD_TYPE,
            ...payValues.BANK_CODE,
            ...payValues.CARD_NATURE,
        };

        const formatItem = item.map((value, index) => {
            let color = '#999';

            if (pieLegends && item) {
                if (pieLegends[value.aggregator]) {
                    color = pieLegends[value.aggregator].color;
                } else if (pieLegends[`rank${index + 1}`]) {
                    color = pieLegends[`rank${index + 1}`].color;
                }
            }
            const payVal =
                (staticValues[value.aggregator] &&
                    staticValues[value.aggregator].codeNameUI) ||
                (pieLegends[value.aggregator] &&
                    pieLegends[value.aggregator].label) ||
                value.aggregator;
            return {
                aggregator: payVal,
                key: value.aggregator,
                color,
                SUCCESS_RATE: value.values.SUCCESS_RATE
                    ? `${value.values.SUCCESS_RATE} %`
                    : 'NA',
                TRANSACTION_COUNT: value.values.TRANSACTION_COUNT || 'NA',
                value: parseInt(value.values.TRANSACTION_COUNT, 10) || null,
            };
        });
        return formatItem;
    }
};

const formatChartDate = (value, granularity) => {
    if (value && granularity) {
        switch (granularity) {
            case 'DAILY':
                return moment(value).format('Do MMM');
            case 'FIFTEENMINUTE':
                return moment(value).format('HH:mm');
            case 'HOURLY':
                return moment(value).format('HH:mm');
            case 'MONTHLY':
                return moment(value).format('MMM `YY');
            case 'WEEKLY':
                return moment(value).format('Do MMM');
            default:
                return value;
        }
    }
    return value;
};

export const getFormattedGranularity = (data, granularity, label) => {
    if (data && granularity && data.length) {
        const sortData = orderBy(data, ['aggregator'], ['asc']);
        const formattedData = sortData.map(item => {
            const formattedItem = {
                aggregator: formatChartDate(item.aggregator, granularity),
                values: {},
            };
            if (!label || label === 'all') {
                formattedItem.values = item.values;
            } else {
                formattedItem.values[label] = item.values[label];
            }
            return formattedItem;
        });
        return formattedData;
    }
    return data;
};

export const checkTabData = (data, label) => {
    if (!isEmpty(data) && !isEmpty(label)) {
        const firstValue = first(data);
        const checkData = Object.keys(firstValue.values).some(
            item => item === label
        );
        if (checkData || label === 'all' || label === 'overall') {
            return false;
        }
        return true;
    }
    return true;
};

export const getTagsValue = data => {
    if (data && data.length) {
        const formattedValue = data.map(item => item.value);
        return formattedValue;
    }

    return [];
};

export const getCommDetails = data => {
    if (
        data &&
        data.transactionStatus !== 'EXPIRED' &&
        data.transactionStatus !== 'TRANSACTION_INITIATED' &&
        data.transactionStatus !== 'TRANSACTION_SUCCESS' &&
        data.transactionStatus !== 'TRANSACTION_FAILED'
    ) {
        const { communicationModeValue } = data;
        // eslint-disable-next-line no-useless-escape
        const expr = /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
        if (expr.test(communicationModeValue)) {
            return { email: [communicationModeValue] };
        }

        return { mobile: [communicationModeValue] };
    }

    return {};
};

export const formatFormDataOptions = (data = [], suffix = '') => {
    return data.map(item => {
        return {
            name: `${item} ${suffix}`,
            value: item,
        };
    });
};

export const updateTxnStatus = (tableData, viewTransactionData) => {
    const updatedTableData = tableData.map(txn => {
        if (
            txn.transactionReferenceNumber ===
            viewTransactionData.details.transactionReferenceNumber
        ) {
            return {
                ...txn,
                transactionStatus:
                    viewTransactionData.details.transactionStatus,
            };
        }

        return txn;
    });

    return updatedTableData;
};

export const nameValueOptions = (states = []) => {
    return states.map(state => {
        const capitalizedState = state.charAt(0).toUpperCase() + state.slice(1).toLowerCase();
        return {
            name: capitalizedState,
            value: state,
        };
    });
};

export const mapMerchant = (merchants = []) => {
    return merchants.map(merchant => {
        return {
            name: merchant.name,
            value: merchant.entityCode,
        };
    });
};

export function isNumeric(value) {
    return /^-?\d+$/.test(value);
}

export const generateCSVFromArray = (csvArray, csvfileName) => {
    const csvContent = `data:text/csv;charset=utf-8,${csvArray
        .map(value => value.join(','))
        .join('\n')}`;
    const encodedUri = encodeURI(csvContent);
    const link = document.createElement('a');
    link.setAttribute('href', encodedUri);
    link.setAttribute('download', csvfileName);
    document.body.appendChild(link);
    link.click();
};

export const downloadFile = url => {
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('target', '_blank');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};

export const getBusinessSources = paymentTypeArray => {
    return paymentTypeArray.txnConfig
        ? paymentTypeArray.txnConfig
            .filter(config => config.businessSource)
            .map(config => config.businessSource)
        : [];
};

export const getBusinessSourcesToAccountTypeMapping = txnConfig => {
    const txnConfigObj = {};

    for (const txn of txnConfig) {
        console.log("accountTypes", txn);

        const businessSource = txn.businessSource;
        const accountTypes = txn.accountType.filter(type => type !== null) || [];


        if (businessSource !== null && accountTypes.length > 0) {
            if (!txnConfigObj[`upiAccountTypes-${businessSource}`]) {
                txnConfigObj[`upiAccountTypes-${businessSource}`] = [];
            }

            txnConfigObj[`upiAccountTypes-${businessSource}`].push(
                ...accountTypes
            );
        }
    }

    return txnConfigObj;
};
export const downloadBulkAccountVerificationPreFilledFileCSV = (csvData, fileName) => {
    try {
        // Convert response to a Blob for file handling
        const fileBlob = new Blob([csvData], { type: 'text/csv' });
        // Create an anchor element to trigger download
        const url = window.URL.createObjectURL(fileBlob);
        const link = document.createElement('a');
        link.href = url;
        link.download = fileName || 'data.csv'; // specify the file name

        // Simulate a click to start the download
        document.body.appendChild(link);
        link.click();

        // Clean up by removing the link
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        return {status: true, message: "Success"};
    } catch (e) {
        return {status: false, message: e.message};
    }
};

export const downloadBulkPaymentLinkPreFilledFileCSV = (
    linkDataId,
    linkName = 'DUMMY_NAME'
) => {
    // Define the CSV content
    const csvContent = `Link ID,${linkDataId},Link Name,${linkName}



Customer ID,Customer Name,Customer Mobile,Cust Email,Min Amount,Max Amount,Validity Period,TimeUnit,Link Type,UDF1,UDF2,UDF3,UDF4,UDF5
CUSTOMER_ID,,,,,,,MINUTE-HOUR-DAY,(PL_LINK/INTENT_LINK),All UDF fields are optional. Please remove sample data from this row and input your entries,udf2,udf3,udf4,udf5`;

    // Create a Blob object
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });

    // Create a temporary download link
    const link = document.createElement('a');
    link.setAttribute('href', URL.createObjectURL(blob));
    link.setAttribute('download', `${linkDataId}.csv`);
    link.style.display = 'none';

    // Append the link to the document body
    document.body.appendChild(link);

    // Trigger the click event on the link
    link.click();

    // Cleanup
    document.body.removeChild(link);
};

export const getFormButtonText = isUserTerminalState => {
    return isUserTerminalState ? 'SUBMIT' : 'NEXT';
};

export const camelCaseToTitle = inputString => {
    const specialCases = ["EDI", "ODS", "TID"];
    const addODS = ["feePercent", "flatFee"];

    if (addODS.includes(inputString)) {
        inputString = `ODS ${inputString.charAt(0).toUpperCase() + inputString.slice(1)}`;
    }

    const newString = inputString.length < 4
        ? inputString.toUpperCase()
        : inputString.replace(/([a-z])([A-Z])/g, '$1 $2');

    let result = newString.charAt(0).toUpperCase() + newString.slice(1);

    specialCases.forEach(caseStr => {
        const regex = new RegExp(caseStr, 'gi');
        result = result.replace(regex, caseStr);
    });

    return result;
};

export const getFormattedPGConfigOldData = draftData => {
    const { paymentGatewayDtoList } = draftData;

    const pgConfigurationDataResponse = {};
    if (paymentGatewayDtoList && paymentGatewayDtoList.length) {
        paymentGatewayDtoList.forEach((selectedPg, index) => {
            const oldConfValues = {
                credentials: selectedPg.credentials.map(cred => {
                    return {
                        ...cred,
                        status: cred.status === true ? ['ENABLED'] : [],
                    };
                }),
                referenceId: 'REFERENCE',
            };
            const confName = `${selectedPg.pgName}Conf${capitalize(
                selectedPg.environment
            )}`;
            pgConfigurationDataResponse[confName] = oldConfValues;
        });
    }

    if (pgConfigurationDataResponse) {
        return pgConfigurationDataResponse;
    }
    return {};
};

export const getActiveReports = reports => {
    const reportsAll = {};
    if (reports.reportsList.length) {
        reportsAll.generating = reports.reportsList.filter(
            item => item.requestStatus !== 'COMPLETED'
        );
        reportsAll.complete = reports.reportsList.filter(
            item => item.requestStatus === 'COMPLETED'
        );
    }
    return reportsAll;
};

export const getRequestData = (payload, isFileRequest = false) => {
    const request = {};

    if (payload.createdOn) {
        request.startDateTime = moment(payload.createdOn.startDate)
            .startOf('day')
            .format('YYYY-MM-DD HH:mm:ss');
        request.endDateTime = moment(payload.createdOn.endDate)
            .endOf('day')
            .format('YYYY-MM-DD HH:mm:ss');
    }

    if (payload.merchantIds && payload.merchantIds.length) {
        request.merchantCodes = payload.merchantIds;
    }

    if (payload.minAmt) {
        request.minAmt = payload.minAmt;
    }

    if (payload.minAmount) {
        request.minAmount = payload.minAmount;
    }

    if (payload.transactionModes) {
        request.transactionModes = [payload.transactionModes];
    }

    if (payload.paymentType) {
        request.paymentType = [payload.paymentType];
    }

    if (payload.maxAmt) {
        request.maxAmt = payload.maxAmt;
    }

    if (payload.maxAmount) {
        request.maxAmount = payload.maxAmount;
    }

    if (payload.transactionTypes && payload.transactionTypes.length) {
        const { transactionTypes } = payload;
        request.transactionTypes = transactionTypes;
    }

    if (payload.mandateStatus) {
        request.status = payload.mandateStatus;
    }

    if (payload.orderId) {
        request.referenceId = payload.orderId;
    }

    if (payload.referenceId) {
        request.subscriptionId = payload.referenceId;
    }

    if (!isFileRequest) {
        request.paginationDetails = {
            pageNo: payload.pageIndex || 1,
            pageSize: payload.pageSize || 10,
        };
    } else {
        if (payload.reportFileName) {
            request.reportFileName = payload.reportFileName;
        }
    }

    return request;
};

// export const setAggregatorFilter = (fieldsList, entityList) => {
//     const { aggregator = [] } = entityList;
//     if (aggregator.length) {
//         fieldsList.forEach(element => {
//             if (element.name === 'aggregatorId') {
//                 element.props.data = aggregator;
//             }
//         });
//         return fieldsList;
//     }
//     return fieldsList.filter(item => item.name !== 'aggregatorId');
// };

export const setAggregatorFilter = (fieldsList, entityList, handleSearchEnd) => {
    const { aggregator = [] } = entityList;
    if (aggregator.length) {
        fieldsList.forEach(element => {
            if (element.name === 'aggregatorId') {
                element.props.data = aggregator;
                element.props.handleSearchEnd = handleSearchEnd;
            }
        });
        return fieldsList;
    }
    return fieldsList;
};

// export const setMerchantFilter = (
//     fieldsList,
//     underlyingMerchant,
//     entityList,
//     selectedAggregator
// ) => {
//     const { merchants = [] } = entityList;
//     if (selectedAggregator) {
//         fieldsList.forEach(element => {
//             if (element.name === 'merchantId') {
//                 element.props.data = merchants;
//             }
//         });
//         return fieldsList;
//     }
//
//     if (underlyingMerchant.length) {
//         fieldsList.forEach(element => {
//             if (element.name === 'merchantId') {
//                 element.props.data = underlyingMerchant;
//             }
//         });
//         return fieldsList;
//     }
//     return fieldsList.filter(item => item.name !== 'merchantId');
// };

export const setMerchantFilter = (
    fieldsList,
    underlyingMerchant,
    entityList,
    selectedAggregator,
    handleSearchEnd
) => {
    const { merchants = [] } = entityList;
    if (selectedAggregator) {
        fieldsList.forEach(element => {
            if (element.name === 'merchantId' || element.name === 'merchantName') {
                element.props.data = merchants;
                element.props.handleSearchEnd = handleSearchEnd;
            }
        });
        return fieldsList;
    }

    if (underlyingMerchant.length) {
        fieldsList.forEach(element => {
            if (element.name === 'merchantId' || element.name === 'merchantName') {
                element.props.data = underlyingMerchant;
                element.props.handleSearchEnd = handleSearchEnd;
            }
        });
        return fieldsList;
    }
    return fieldsList;
};

export const chunkArray = (arr, chunkSize) => {
    const result = [];
    for (let i = 0; i < arr.length; i += chunkSize) {
        result.push(arr.slice(i, i + chunkSize));
    }
    return result;
};

/**
 * Function to generate an error message object.
 * @param {string} [error] - The error message. Optional, defaults to "Something Went Wrong!!" if not provided.
 * @returns {{message: string, imageSrc: string}} - The error message object.
 */
export const ERROR = error => {
    return {
        message: error || 'Something Went Wrong!!',
        imageSrc: errorImage,
    };
};

export const isPresentOrDefault = (value, defaultValue) => {
    return value ? value : defaultValue;
};

export const isAdminUser = auth => {
    return auth?.userDetails?.userLevel === 'ADMIN';
};

export const isMerchantUser = auth => {
    return auth?.userDetails?.userLevel === 'MERCHANT';
};

export const capitalizeFirstLetter = (str) => str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();

export const capitalizeFirstLetterOfEachWord = (str) => {
    try {
        return str
            .split(' ') // Split the string by spaces into an array of words
            .map(word => capitalizeFirstLetter(word)) // Capitalize each word
            .join(' '); // Join the array back into a string with spaces
    } catch(e) {
        console.log("e message", e?.message);
    }
    return '';
}

export const createDeepCopyObj = (data) => {
    if (typeof data === 'object') {
        return JSON.parse(JSON.stringify(data));
    }
    return data;
}

export const isValidTimestamp = (timestamp) => {
    if(!timestamp) return false;
    const ts = Number(timestamp); // Coerce to proper number
    const date = new Date(ts);
    return !isNaN(date.getTime());
};
